"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgExpand(props) {
    return React.createElement(
        "svg",
        Object.assign({
            xmlns: "http://www.w3.org/2000/svg",
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "currentColor"
        }, props),
        React.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            React.createElement("path", {
                fill: "currentColor",
                d: "M18.655 12.795a1.094 1.094 0 0 0 0-1.59l-5.314-4.986a.813.813 0 0 0-1.111 0 .726.726 0 0 0 0 1.06L17.267 12l-5.037 4.72a.726.726 0 0 0 0 1.061.812.812 0 0 0 1.111 0l5.314-4.985zm-6 0a1.094 1.094 0 0 0 0-1.59L7.341 6.219a.813.813 0 0 0-1.111 0 .726.726 0 0 0 0 1.06L11.267 12 6.23 16.72a.726.726 0 0 0 0 1.061.812.812 0 0 0 1.111 0l5.314-4.985z"
            })
        )
    );
}
exports.default = SvgExpand;